define('view/controller/booking/datetime/event/TimeEventView',['require','view/controller/booking/datetime/TimeDefaultView','view/controller/booking/datetime/event/TimeEventItemView','lib/model/BaseModel','Config'],function (require) {

    var TimeDefaultView = require('view/controller/booking/datetime/TimeDefaultView');
    var TimeEventItemView = require('view/controller/booking/datetime/event/TimeEventItemView');
    var BaseModel = require('lib/model/BaseModel');
    var Config = require('Config');

    /**
     * Event timeline view (container)
     *
     * @class TimeEventView
     */
    return TimeDefaultView.extend({

        template: '#time_event_view',
        childView: TimeEventItemView,
        childViewContainer: '#sb_time_event_container',
        childViewOptions: function () {
            return {
                bookingModel: this.model,
                calendarData: this._calendarData,
            };
        },
        childEvents: {
            'hover:date': 'onDateHover',
            'select:date': 'onDateSelected'
        },

        _timeCollection: null,
        _calendarCollection : null,

        _currentYear: null,
        _currentMonth: null,
        _dates: [],
        _calendarData : null,

        initialize: function () {
            this._timeCollection = this.getOption('timeCollection');
            this._calendarCollection = this.getOption('calendarCollection');

            this.listenTo(this._calendarCollection, 'sync', _.bind(function () {
                this._updateCollection();
                this.render();
            }, this));

            TimeDefaultView.prototype.initialize.apply(this);
        },

        serializeData : function () {
            var res = TimeDefaultView.prototype.serializeData.apply(this);
            res['calendar_data'] = this._calendarData;
            return res;
        },

        _updateCollection: function () {
            this._calendarData = this._makeCalendarData();
            this.collection = this._calendarCollection;
        },

        _makeCalendarData: function () {
            var result = {};
            var days = this._calendarCollection.toJSON();
            var date = new Date();
            var dateStr = date.getMysqlDate();

            result.week_days = date.getWeekDaysList('medium');
            result.weekends = [0, 6];
            if (Config.getInstance().isMondayFirstDay()) {
                result.weekends = [5, 6];
            }

            result.days = days;
            result.current_year = this._currentYear;
            result.current_month = this._currentMonth;
            result.first_day = result.current_year + '-' + (result.current_month+1) + '-' + '01';

            return result;
        },


        onDateHover : function (event, model) {

        },

        onDateSelected : function (event, model) {
            var instance = this;
            var date = model.get('date');

            this.model.set('selected_date', date);

            this.listenTo(this._timeCollection, 'sync', _.bind(function () {
                var isTimeFinded = false;

                if(this._timeCollection.length) {
                    this._timeCollection.each(function (timeModel) {
                        if (!isTimeFinded && timeModel.get('type') == 'free') {
                            isTimeFinded = true;
                            instance.triggerMethod('timeChanged', timeModel.get('time'), date);
                        }
                    });
                } else{
                    this.showErrorMessage(Locale.getNonEscape('selected_date_slot_are_not_available'));
                }
            }, this));
        },


        setCurrentYearMonth : function (year, month) {
            if(month){
                this._currentMonth = month;
            }
            if(year){
                this._currentYear = year;
            }
        }


    });

});
